import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { ReservationQuestionAnswer } from 'projects/qcloud-models/reservation/reservation-question-answer';
import { ReservationQuestionType } from 'projects/qcloud-models/reservation/reservation-question-type.enum';
import { ReservationQuestion } from 'projects/qcloud-models/reservation/reservation-questions';
import { ReservationPluginService } from '../../../services/reservation-plugin.service';
import { TicketReservationService } from '../../../services/ticket-reservation.service';

@Component({
  selector: 'app-reservation-questionaire',
  templateUrl: './reservation-questionaire.component.html',
  styleUrls: ['./reservation-questionaire.component.scss']
})
export class ReservationQuestionaireComponent implements OnInit {

  @Input() questions: ReservationQuestion[];
  ticketReservation = new TicketReservationPlugin();
  reservationQuestions: ReservationQuestionAnswer[];
  ReservationQuestionType = ReservationQuestionType;
  @Output() formInvalid = new EventEmitter();
  containsLinkRegex = new RegExp("([a-zA-Z\d]+[.][A-Za-z]{2,4})");
  textInvalid = false;

  constructor(private ticketReservationService: TicketReservationService, private translate: TranslateService,
    public reservationPluginService: ReservationPluginService) {
    ticketReservationService.ticketReservation.subscribe((val: TicketReservationPlugin) => {
      this.ticketReservation = val;
    });

    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      let locale = event.lang;
      this.reservationQuestions.forEach(question => {
        let parentQuestion = this.questions.find(x => x.id == question.questionId);
        question.question = parentQuestion.translations.find(x => x.locale.slice(0, 2) == locale)?.translation ??
          parentQuestion.question;
      });
    });
  }

  ngOnInit(): void {
    this.reservationQuestions = this.questions.map(question =>
      new ReservationQuestionAnswer(question, this.translate.currentLang));
    this.formInvalid.emit(true);
  }

  updateTicketReservation(formInvalid: boolean) {
    this.ticketReservation.additionalReservationData = this.reservationQuestions;
    this.ticketReservationService.updateTicketReservation(this.ticketReservation);
    this.updateTicketReservationCategory();
    if (this.invalidEmailOrPhoneNumber()) {
      formInvalid = true;
    }
    this.formInvalid.emit(formInvalid || this.textInvalid);
  }

  checkForUrls(answer: string) {
    if (this.containsLinkRegex.test(answer)) {
      this.textInvalid = true;
      this.updateTicketReservation(true);
    }
    else {
      this.textInvalid = false;
    }
  }

  updateTicketReservationCategory() {
    let caseAnswer = this.ticketReservation.additionalReservationData.find(x => x.questionType == ReservationQuestionType.Case);
    let clientAnswer = this.ticketReservation.additionalReservationData.find(x => x.questionType == ReservationQuestionType.Client);
    if (caseAnswer != null && clientAnswer != null && caseAnswer.answer != null && clientAnswer.answer != null) {
      this.ticketReservation.categoryId = this.reservationPluginService.getCategoryId();
      this.ticketReservationService.updateTicketReservation(this.ticketReservation);
    }
  }

  invalidEmailOrPhoneNumber(): boolean {
    let emailAnswer = this.ticketReservation.additionalReservationData.find(x => x.questionType == ReservationQuestionType.Email);
    let phoneAnswer = this.ticketReservation.additionalReservationData.find(x => x.questionType == ReservationQuestionType.PhoneNumber);
    return !emailAnswer.answer && !phoneAnswer.answer;
  }

  validateNumber(event) {
    const keyCode = event.keyCode;

    const excludedKeys = [8, 37, 39, 46, 187, 189];

    if (!((keyCode >= 48 && keyCode <= 57) ||
      (keyCode >= 96 && keyCode <= 105) ||
      (excludedKeys.includes(keyCode)))) {
      event.preventDefault();
    }
  }

  preventNumber(event) {
    const keyCode = event.keyCode;

    if (keyCode >= 48 && keyCode <= 57) {
      event.preventDefault();
    }
  }
}
